import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';

interface ComingSoonProps {
  title: string;
  description: string;
}

/**
 * Placeholder for navigation destinations that exist in the design but have no
 * functionality behind them yet.
 */
const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: 'flex', justifyContent: 'center' }}>
      <Paper
        variant="outlined"
        sx={{ p: 5, maxWidth: 560, width: '100%', textAlign: 'center', mt: 6 }}
      >
        <ConstructionIcon sx={{ fontSize: 44, color: 'primary.main', mb: 1 }} />
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/pending-loads')}>
          Back to Pending Loads
        </Button>
      </Paper>
    </Box>
  );
};

export default ComingSoon;
